import { jwtDecode } from 'jwt-decode';
import AuthUtils from '../auth/auth_utils';

const urlhost = window._env_?.REACT_APP_HOST;

const fetchToken = async (authCode) => {
    const tokenUrl = window._env_?.REACT_APP_AUTH_GET_TOKEN_URL;
    const callback = window._env_?.REACT_APP_AUTH_CALLBACK_URL;

    try {
        const response = await fetch(tokenUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ code: authCode, redirect_uri: callback })
        });

        const data = await response.json();
        return data; 
    } catch (error) {
        console.error('Error:', error);
        throw error; 
    }
}

const fetchData = async (url, payload) => {
    try {
        const token = AuthUtils.GetAuthToken();
        
        if (token) {
            if (isTokenExpired(token)) {
                console.warn('Token expired, redirecting to login');
                await clearTokenAndLogin();
                return;
            }
            
            const response = await fetch(url, payload);
            
            if (response.status === 401) {
                console.warn('Unauthorized response. Notify the caller to handle this case.');
                throw new Error('Unauthorized');
            }
            
            const data = await response.json();
            
            return data;
        } else {
            console.error('No auth token available');
            return null;
        }
    } catch (error) {
        console.error('Error in fetchData:', error.message);
        throw error; 
    }
}

const requestData = async (path, method, payload) => {
    try {
        if (!urlhost) {
            console.error('❌ REACT_APP_HOST is not configured in window._env_');
            throw new Error('API host not configured');
        }
        
        const headers = getHeaders();
        const cleanUrlhost = urlhost.replace(/\/$/, '');
        const cleanPath = path.replace(/^\//, '');
        const requestUrl = `${cleanUrlhost}/${cleanPath}`;

        const options = {
            method: method,
            headers: headers
        };

        if (payload) {
            options.body = JSON.stringify(payload);
        }

        const data = await fetchData(requestUrl, options);

        return data;
    } catch (error) {
        console.error(`HTTP Error for ${method} ${path}:`, error.message);
        throw error; 
    }
}

const getHeaders = () => {
    try {
        const token = AuthUtils.GetAuthToken();
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return headers;
    } catch (error) {
        console.error('Error:', error);
        throw error; 
    }
}

const clearTokenAndLogin = async () => {
    AuthUtils.ClearAuthToken();
    window.location.href = '/login';
}

function isTokenExpired(token) {
    if (!token) {
        return true; 
    }
    try {
        const decoded = jwtDecode(token);
        const currentTimestamp = Date.now() / 1000;  // Current time in seconds since epoch
        if (decoded.exp < currentTimestamp) {
            return true;  
        }
    } catch (error) {
        console.error('Failed to decode JWT:', error);
        return true;  
    }
    return false; 
}

export const authTokenService = {
    fetchToken,
};

export const dataService = {
    fetchData,
    requestData, 
    fetchToken
};